const TableSummary = ({
  dataLength = 0,
  currentPage,
  perPage,
  pageCount,
  total,
  isLoading = false,
}) => {
  const page = Number(currentPage);
  const size = Number(perPage);
  const pages = Number(pageCount);
  const knownTotal = total !== undefined && total !== null && Number.isFinite(Number(total));
  const hasRange = Number.isFinite(page) && page >= 1 && Number.isFinite(size) && size > 0;
  const first = hasRange && dataLength > 0 ? (page - 1) * size + 1 : 0;
  const last = dataLength > 0 ? first + dataLength - 1 : 0;

  return (
    <p className='text-sm text-gray-500' aria-live='polite'>
      {isLoading
        ? 'Memuat data...'
        : hasRange
          ? `Menampilkan ${first}–${last}${knownTotal ? ` dari ${Number(total)} data` : ' data'}`
          : `${dataLength} data ditampilkan`}
      {!isLoading && page >= 1 && pages >= 1 ? ` · Halaman ${page} dari ${pages}` : ''}
    </p>
  );
};

export default TableSummary;
